import angularModule from 'ProjectGroup/angularModule/scripts/project_groups_module';

angularModule.factory('ProjectGroup', [
    '$injector',
    $injector => {
        const Iguana = $injector.get('Iguana');

        return Iguana.subclass(function () {
            this.setCollection('project_groups');
            this.alias('ProjectGroup');
            this.setIdProperty('id');

            return {};
        });
    },
]);
